<template>
  <div class="hello">
    <div class="bgmask" v-if="addShow">

      <div class="addEvent">
        <div class="close" @click="closeEvent">
          <img src="../assets/image/close.png" alt="">
        </div>

        <div class="addNav">
          <span>{{$t('language.photographer')}}</span>
        </div>
        <div class="parent">
          <div class="formList" :class="{isa:item.isActive,isb:item.isBottom}" v-for="(item,index) in formList" :key="index">
            <div class="headImage">
              <div class="form_rules">
                <span>{{$t('language.must')}}</span>
              </div>
              <div class="form_ti">
                <span>{{item.name}}</span>
              </div>
              <div class="add_type">
                <div class="form_t" v-if="item.type  == 'upload'">
                  <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                    :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </div>
                <div class="form_t" v-if="item.type == 'input'">
                  <el-input :disabled="disabled" v-model="item.value"></el-input>
                </div>
                <div class="form_t" style="width: 399px;" v-if="item.type == 'select'">
                  <el-select :disabled="disabled" v-model="item.value" :placeholder="$t('language.place')">
                    <el-option v-for="(item,index) in item.option" :key="index" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
                <div class="form_t" v-if="item.type == 'radio'">
                  <el-radio :disabled="disabled" v-model="item.value" v-for="(ite,ind) in item.field_option" :key="ind"
                    :label="ite">{{ite}}</el-radio>
                </div>

                <input ref="filElem" type="file" class="upload-file" @change="uploadChange" style="display: none;">

                <div class="form_t" v-if="item.type == 'image'">
                  <div class="upoadImas" v-if="uploadImage != ''" @click="uploadHead">

                    <img :src="uploadImage" alt="">
                  </div>
                  <div class="upoadImas" v-else @click="uploadHead">
                    <img v-if="lang == 'cn'" src="../assets/image/upload.png" alt="">
                    <img v-else src="../assets/image/uploadEn.png" alt="">

                  </div>
                </div>
                <div class="form_t" v-if="item.type == 'textarea'">
                  <textarea :disabled="disabled" value="" style="padding-left: 15px;padding-top: 15px;" v-model="html"
                    placeholder="" />
                  </div>

                    <input :disabled="disabled" ref="filE" type="file" multiple class="upload-file" @change="getFile" style="display: none;">

                  <div class="form_t" v-if="item.type == 'images'">
                    <div class="imageList" v-for="(item,index) in singleArray" :key="index">
                      <img :src="item.file_path" alt="">
                      <div class="clos" @click="cloesEv(index)">
                        <img src="../assets/image/close.png" alt="">
                      </div>
                    </div>
                    <div class="uploadImages" @click="uploadEvent">
                      <img src="../assets/image/add.png" alt="">
                    </div>
                  </div>
                  <!-- <div class="form_t" v-if="item.type =='textarea'" style="height: 300px;">
                        <quill-editor :disabled="disabled" class="sada" style="height: 200px" v-model="content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)"
                          @focus="onEditorFocus($event)" @change="onEditorChange($event)">
                        </quill-editor>
                  </div> -->

                </div>
                <div class="clear"></div>
              </div>
        </div>
					<div class="sumitAdd" v-if="subShow" @click="submitBtn">
                <span>{{$t('language.submit')}}</span>
          </div>
		  <div style="height:20px"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    quillEditor
  } from 'vue-quill-editor'
  const toolbarOptions = [
    ['image'], // remove formatting button
      [{ 'size': ['small', false, 'large'] }],
            ['bold', 'italic'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link', 'image'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
  ]
  import VDistpicker from 'v-distpicker'
  export default {
    components: {
      VDistpicker
    },
    props:{
      addShow:{
        type:Boolean,
        default:false
      },
      exhibitionid:{
        type:String,
        default:''
      },
      showId:{
         type:Number,
         default:null
      },
      dataList:{
        type:Object,
        default:{}
      },
      isFlag:{
        type:Boolean,
        default:false
      },
       details:{
         type:Object,
         default:{}
       }
    },
    data() {
      return {
      dialogImageUrl: '',
      dialogVisible: false,
      maskShow:true,
      uploadRichTextImg: '', //上传图片地址接口
        content: '', //富文本里的内容
        editorOption: { //富文本编辑器的工具栏
          modules: {
            toolbar: {
              container: toolbarOptions, // 工具栏
              // handlers: {
              //   'image': function(value) { // 对图片进行改造，默认是通过base64 ,现通过iview 去传。
              //     if (value) {
              //     } else {
              //       this.quill.format('image', false);
              //     }
              //   }
              // }
            },
          },
          imageResize: {}, //自定义拉伸
          placeholder: '请输入文章内容',
          html:''
        },
        contentTxt: '', //富文本编辑器里的前面100个文字
      obj:{},
        imageUrl: '',
        userId:0,
        singleArray:[],
        slist:[],
        formList:[],
        disabled:false,
        subShow:true,
        uploadImage:'',
        lang:'cn'
      }
    },
    computed:{

    },
     created(){
       if(localStorage.getItem('languageSet') == 'zh'){
         this.lang = 'en'
       }else{
         this.lang = 'cn'
       }
       console.log(this.uploadImage);
      this.formList = [
          {
            name: this.$t('language.yourname'),
            type: 'input',
            value:''
          },
          {
            name:this.$t('language.sex'),
            type :'radio',
            value:'',
            field_option:[
                this.$t('language.male'),
                this.$t('language.female')
            ]
          },
		{
		  name:this.$t('language.uploadHead'),
		  type:'image',
		  value:''
		},
		{
		  name: this.$t('language.idcard'),
		  type: 'input',
		  value:''
		},
		{
		  name: this.$t('language.phoneNumber'),
		  type: 'input',
		  value:''
		},
		{
		  name: this.$t('language.country'),
		  type: 'input',
		  value:''
		},
          {
            name: this.$t('language.sheng'),
            type: 'input',
            value:'',
            option:[]
          },
          
          
          
          
          {
            name: this.$t('language.email'),
            type: 'input',
            value:''
          },
          {
            name:this.$t('language.resume'),
            type:'textarea',
            value:''
          },
		  {
		    name:this.$t('language.label'),
		    type:'select',
		    value:'',
		    option:[]
		  },
          {
            name:this.$t('language.Upload'),
            type:'images',
            value:''
          }
        ];
        console.log(this.details);

       for(var i = 0; i < this.formList.length;i++){
         this.formList[i].value = ''
       }
       this.html= '';
       this.uploadImage = ''
       this.$fetch('/Apply/labelList').then(res=>{
        console.log(res)
        this.formList[9].option = res.data;
       })

     },
     watch: {
         dataList(val) {
           console.log(this.$parent.isEditPhotographer)
          if(this.$parent.isEditPhotographer){
			  console.log(val,'1233')
              if(JSON.stringify(val) != '{}'){
                  this.userId = val.id;
                  this.formList[0].value = val.name;

                  this.formList[1].value = val.sex;
                  this.formList[3].value = val.idcard;
                  this.formList[4].value = val.phone;
                  this.formList[6].value = val.province;
                  // this.formList[6].value = val.phone;
                  this.formList[9].value = val.label;
                  this.formList[7].value = val.email;
				  this.formList[8].value = val.art_history;
				  this.formList[5].value = val.country
                  this.uploadImage = val.img_src;
                  // this.content = val.art_history;
                  this.html = val.art_history
                  var arr = [];
                  this.singleArray = val.single ? val.single : [];
                console.log(this.singleArray);
              }

          }

         },
         details(val){
           if(val.audit_status == 2 || val.audit_status == -1){
             this.disabled = false;
             this.subShow = true;
           }else{
             this.disabled = true;
             this.subShow = false;
           }
         }
       },

    methods: {
      uploadHead(){
        console.log(this.details);
        console.log(JSON.stringify(this.details))
         if(JSON.stringify(this.details) == '{}'){
              this.$refs.filElem[0].dispatchEvent(new MouseEvent('click'))
              return  false;
         }
            if(this.details.audit_status == 2 || this.details.audit_status == -1){
            this.$refs.filElem[0].dispatchEvent(new MouseEvent('click'))
            }else{
              this.$message.error('无法上传')
              return false
            }

      },
      uploadChange(el){
       var file = el.target.files[0];
       var blob = new Blob([file]);
       // var fileSize = 0;
       // var fileMaxSize = 1024; //1M
       // var fileSize = file.size;
       // var size = fileSize / 1024;
       // if (size > fileMaxSize) {
       //   console.log('25545')
       //   this.$message.error('文件不能大于1M')
       //   return false
       // }
       if(file.type != 'video/mp4'){
          const blobUrl = window.URL.createObjectURL(blob);
          // this.uploadImage = blobUrl;
           var that = this;
          let formData = new FormData();
          formData.append("file", file);
          var data = formData;
          this.$post('/Upload/image', data).then(res => {
            if(res.code == 200){
              this.uploadImage = res.data.file_path;
            }
          })
           el.target.value='';
       }else{
         this.$message.error(this.$t('language.upload'))
       }

      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      handleRemove(file, fileList) {
              console.log(file, fileList);
            },
        handlePictureCardPreview(file) {
          console.log(file.url)
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        uploadEvent(){
          console.log('sadaw')
          this.$refs.filE[0].dispatchEvent(new MouseEvent('click'))
        },
        getFile(el) {
             var file = el.target.files;
             var blob = new Blob([file]);
             // var fileSize = 0;
             // var fileMaxSize = 1024; //1M
             // var fileSize =file.size;
             // var size = fileSize / 1024;
             // if(size  > fileMaxSize){
             //   console.log('25545')
             //   this.$message.error('文件不能大于1M')
             //    return false
             // }
             console.log(this.singleArray);
            for(var i = 0; i < file.length;i++){
              if(file[i].type != 'video/mp4'){
                  let formData = new FormData();
                  formData.append("file", file[i]);

                  this.$post('/Upload/image',formData).then(res=>{
                    if(res.code == 200){
                      this.singleArray.push(res.data);
                      console.log(this.singleArray)
                    }
                  })
              }else{
                this.$message.error(this.$t('language.upload'))
              }

            }




            const blobUrl = window.URL.createObjectURL(blob);
            // this.uploadList.push(blobUrl)
        },
        cloesEv(index){
          console.log(this.details.audit_status);
          if(this.details.audit_status == 1 || this.details.audit_status == 0 ){
            this.$message.error(this.$t('language.del'))
            return false;
          }
          var deleteItem = this.singleArray.splice(index,1)

          console.log(this.$parent.isEditPhotographer);

          // 编辑时删除图片，才需要调用接口
          if (this.$parent.isEditPhotographer == false) {
            return false;
          }


          var data = {id: deleteItem[0].id}
          this.$fetch('/Apply/delWork',data).then(res=>{
            this.$message.success('删除成功');
            console.log(res);
          })
        },
       submitBtn(){
		if(this.formList[0].value == ''){
			 this.$message.error(this.$t('language.nameMessage'));
			 return 
		}
		if(this.formList[1].value == ''){
			 this.$message.error(this.$t('language.sexMessage'));
			 return 
		}
		
		if(this.formList[6].value == ''){
			this.$message.error(this.$t('language.provinceMessage'));
			return 
		}
		
		
		if(this.uploadImage == ''){
			this.$message.error(this.$t('language.id_src'));
			return 
		}
		
		
		if(this.formList[9].value == ''){
			this.$message.error(this.$t('language.label_message'));
			return 
		}
		
		
		if(this.formList[3].value == ''){
			this.$message.error(this.$t('language.idcardmessage'));
			return 
		}
		
		
		if(this.formList[4].value == ''){
			this.$message.error(this.$t('language.phoneMessage'));
			return 
		}
		if(this.formList[5].value == ''){
			this.$message.error(this.$t('language.countryMessage'));
			return 
		}
		
		if(this.formList[7].value == ''){
			this.$message.error(this.$t('language.emailmessage'));
			return 
		}
		
		
		if(this.html == ''){
			this.$message.error(this.$t('language.htmlmessage'));
			return 
		}
		
		if(this.singleArray.length <= 0){
			this.$message.error(this.$t('language.photoMessage'));
			return 
		}
		
		
          var data = {
            id: this.$parent.isEditPhotographer ? this.userId : 0,
            exhibition_apply_id:this.exhibitionid,
            name:this.formList[0].value,
            sex:this.formList[1].value,
            country:this.formList[5].value,
            province:this.formList[6].value,
            label:this.formList[9].value,
            idcard:this.formList[3].value,
            phone:this.formList[4].value,
            email:this.formList[7].value,
            single:this.singleArray,
            img_src:this.uploadImage,
            art_history:this.html
          }

          console.log(data.single);
          console.log(this.$parent.isEditPhotographer);
          // var url = 'http://shoot.test/api/Apply/savePhotographer'

          // this.$post(url, data).then(res=>{
          this.$post('/Apply/savePhotographer',data).then(res=>{
              if(res.code == 400){
                return false;
              }
              this.$parent.addShow = false;
              // this.$emit('parentShow',false);
              this.$parent.addS = false;

              var list = this.slist;
              var hasTab = false;

              for(var i = 0;i < list.length; i++){
                  if(list[i].id == res.data.id){
                    hasTab = true;
                    list[i].name = res.data.name;
                    break;
                  }
              }

              if (!hasTab) {
                list.push({id: res.data.id, name: res.data.name});
              }

              this.slist = list;

              if(this.isFlag){
                  this.$parent.ajaxFun();
              }

              this.$emit('baseData',this.slist);


                for(var i = 0; i < this.formList.length;i++){
                    this.formList[i].value = ''
                }
                this.singleArray = []
                this.uploadImage = '';
                this.html= ''
          })

       },

       closeEvent(){
         this.addShow = false;
         this.userId = 0;
         for(var i = 0; i < this.formList.length;i++){
           this.formList[i].value = ''
         }
         this.uploadImage = ''
         this.html = ''
         this.singleArray = []
         this.$emit('parentShow',this.addShow)
       },
       onEditorChange(e) {
         let _this = this;
         console.log(e.html);
         _this.html = e.html;
         // _this.content = e.html; //标签以<p></p> 形式渲染 （重点）
         _this.contentTxt = e.text.substr(0, 100);
         console.log(_this.contentTxt)
       },
       // 富文本获取焦点事件
       onEditorFocus(e) {
       },
       // 富文本失去焦点事件
       onEditorBlur(e){
       },

       handleSuccessQuill(res) {
         console.log(res)
         // 获取富文本组件实例
         let quill = this.$refs.myQuillEditor.quill
         // 如果上传成功
         if (res) {
           // 获取光标所在位置
           let length = quill.getSelection().index;
           // 插入图片，res为服务器返回的图片链接地址
           quill.insertEmbed(length, 'image', res.data.path)
           // 调整光标到最后
           quill.setSelection(length + 1)
         } else {
           // 提示信息，需引入Message
          this.$message({
             duration:600,
             message:'图片上传失败',
             type:'error'
          })
         }
       },
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/addphotographer.css");
</style>



// WEBPACK FOOTER //
// src/components/addphotographer.vue